<template>
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <p>&copy; 2024 Latino Seguros. Todos los derechos reservados.</p>
          <nav>
            <ul>
              <li><a href="/about">Sobre Nosotros</a></li>
              <li><a href="/contact">Contacto</a></li>
              <li><a href="/privacy">Política de Privacidad</a></li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'Footer'
  }
  </script>
  
  <style scoped>
  /* .footer {
    background-color: #003c71;
    color: #fff;
    padding: 20px 0;
    text-align: center;
    width: 100%;
  }
  
  .footer .container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .footer-content {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 1200px;
    padding: 0 20px;
  }
  
  .footer-content p {
    margin: 0;
  }
  
  .footer nav ul {
    list-style: none;
    display: flex;
    gap: 20px;
    margin: 0;
    padding: 0;
  }
  
  .footer nav ul li a {
    color: #fff;
    text-decoration: none;
  }
  
  .footer nav ul li a:hover {
    text-decoration: underline;
  } */
  </style>
  